(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-expediente-juridicos-judiciales", {
                parent: "entity",
                url: "/consortium-expediente-juridicos-judiciales?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteJuridicoJudicial",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-judiciales/consortium-expediente-juridicos-judiciales.html",
                        controller: "ConsortiumExpedienteJuridicoJudicialController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-expediente-juridicos-judiciales.new", {
                parent: "consortium-expediente-juridicos-judiciales",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-judiciales/consortium-expediente-juridicos-judiciales-new.html",
                        controller: "ConsortiumExpedienteJuridicoJudicialNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-expediente-juridicos-judiciales",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-juridicos-judiciales",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-expediente-juridicos-judiciales.edit", {
                parent: "consortium-expediente-juridicos-judiciales",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteJuridicoJudicial",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-judiciales/consortium-expediente-juridicos-judiciales-detail.html",
                        controller: "ConsortiumExpedienteJuridicoJudicialDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-expediente-juridicos-judiciales",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumExpedienteJuridicoJudicial",
                        function (
                            $stateParams,
                            ConsortiumExpedienteJuridicoJudicial
                        ) {
                            return ConsortiumExpedienteJuridicoJudicial.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-juridicos-judiciales",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();
